$(document).ready(function () {	
    const components = document.querySelectorAll('.cmp-flindersonline-compare-courses');
    if (components.length > 0) {
        components.forEach(component => {
            // const component = document.querySelector(".cmp-flindersonline-compare-courses");         
            const cardHolder = component.querySelector('.compare-courses-holder');
            const cards = component.querySelectorAll(".course-card");
            const noneFound = component.querySelector(".no-courses-found");
            var url = component.dataset.endpoint; 
            var resourcePath = component.dataset.resourcePath;
            var showLimit = 3;
            var paths = []; 
            var savedCourses =[];
            var fieldKeys = [];
            
            const dataArray = Array.from(document.querySelectorAll('.courses-js-data')).map(el => ({
                dataTitle: el.dataset.title,
                dataField: el.dataset.field,
                dataLinkTitle: el.dataset.linkTitle,
                iconImage: el.dataset.icon,
                visibleFor: el.dataset.visiblefor,
                dataSubField: el.dataset.subfield
            }));

            function initSavedCourses(){
                const saved = localStorage.getItem('flinders_saved_courses');
                paths = saved ? JSON.parse(saved) : [];
                savedCourses = [];

                if(paths.length > 0){
                    $.ajax({
                        url: url,
                        type: "POST",
                        data: JSON.stringify({"paths": paths, "resource": resourcePath}),
                        contentType: 'application/json',
                        success: function(response){
                            savedCourses = response;
                            loadCourses(savedCourses);
                        }
                    });
                }else{
                    cardHolder.innerHTML = '';
                    noneFound.classList.add('active');
                }
            }

            function loadCourses(courses){
                cardHolder.innerHTML = '';

                for (var i = 0; i < showLimit; i++) {
                    var course = courses[i];
                    var isEmpty = !course;                   
                    
                    var courseDetails = course || { path: '', previewImagePath: '', courseName: '' }; 
                    if(!isEmpty){
                        cardHolder.innerHTML += loadCourseDetails(courseDetails, i);
                    }else{
                        cardHolder.innerHTML += '<div class="course-card"></div>';
                    }                    
                }

                checkFieldKeySizes();
            }

            function createExtraFieldsHTML(course) {
                var extraFieldsHTML = '';
                fieldKeys = [];
                const visibleForCookie = getCookie('L923DF8dff830dfj2ft3f82mvhao4') || '';
                
                dataArray.forEach(config => {
					var visibleFor = config.visibleFor || 'domestic international';
					
					if(visibleFor && visibleFor.indexOf(visibleForCookie) > -1) {				
                    	var fieldKey = typeof config.dataField === 'object' ? JSON.stringify(config.dataField) : config.dataField;
                    	var title = config.dataTitle || fieldKey;
                    	var icon = config.iconImage ? '<img src="' + config.iconImage + '">' : '';
                    	var values = typeof config.dataField === 'object' ? config.dataField : course[fieldKey];
                    	var linkTitle = config.dataLinkTitle || 'View here';
                    	fieldKeys.push(fieldKey);

                    	var displayValue = getDisplayValue(values, config.dataField, linkTitle, config.dataSubField);
                    
                    	extraFieldsHTML += 
                        	'<div class="course-field-group ' + fieldKey + '">' + 
                        	'<div class="course-data-field">' +
	                        '<div class="ico">' + icon + '</div>' +
                        	'<div class="dataField">' + title + '</div>' +
                        	'</div><div class="course-data-info">' +
                        	'<div class="ico"></div>' +
                        	'<div class="dataField">' + displayValue + '</div></div></div>';
                    }
                });
                
                return extraFieldsHTML;
            }

            function getDisplayValue(values, dataField, linkTitle, dataSubField) {
                // Handle object dataField (like fee objects)

                /*if(typeof dataField === 'string' && dataField.toLowerCase().endsWith('link')){
                    return values ? '<a href="' + values + '" target="_blank">View here</a>' : '';
                }*/

                if (typeof dataField === 'object') {
                    var objectHTML = '';
                    for (var key in dataField) {
                        if (dataField.hasOwnProperty(key) && dataField[key] !== null && dataField[key] !== undefined) {
                            objectHTML += key + ': ' + dataField[key] + '<br>';
                        }
                    }
                    return objectHTML || '';
                }
                
                // Handle arrays
                if (Array.isArray(values)) {
                    if (values.length === 0) return '';

                    const allPlainStrings = values.every(item =>
                        typeof item === 'string' && !((item.startsWith('{') && item.endsWith('}')) || isLink(item))
                    );

                    if (allPlainStrings) {
                        return values.join(', ');
                    }
                    
                    var arrayHTML = '';
                    values.forEach(function(item, idx) {
                        if (typeof item === 'string' && item.startsWith('{') && item.endsWith('}')) {
                            // Parse JSON string
                            try {
                                arrayHTML += getJsonObjectDisplay(item, dataSubField) + (idx != values.length-1 ? '<br>': '');
                            } catch (e) {
                                arrayHTML += item + '<br>';
                            }
                        } else if (typeof item === 'string' && isLink(item)) {
					        arrayHTML += '<a href="' + item + '" target="_blank">' + linkTitle + '</a><br/>';				
			            } else {
                            arrayHTML += item + '<br>';
                        }
                    });
                    return arrayHTML || '';
                }
                
                // Handle value as Link
                if (typeof values === 'string' && isLink(values)) {
					return values ? '<a href="' + values + '" target="_blank">' + linkTitle + '</a>' : '';				
			    }
                
                // Handle value as JSON Object
                if (typeof values === 'string' && values.startsWith('{') && values.endsWith('}')) {
					return getJsonObjectDisplay(values, dataSubField);					
			    }
                
                // Handle other values (strings, booleans, numbers)
                if (values !== null && values !== undefined && values !== '') {
                    if(values === true) return 'Yes';
                    if(values === false) return 'No';

                    return values;
                }
                
                return '';
            }
            
            function getJsonObjectDisplay(value, dataSubField) {
				
				var arrayHTML = '';
				if(dataSubField && dataSubField != '') {
	                var parsed = JSON.parse(value);
	                var dataSubFieldJson = JSON.parse(dataSubField);
	                dataSubFieldJson.forEach(function(itm, idx){
						var key = itm.dataField;

						if(key.endsWith('Fee') || key.endsWith('fee')){
	                        let amount = parsed[key];
	                        if (!isNaN(amount) && amount !== '') {
	                            amount = Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	                        }
	                        arrayHTML += itm.title + ': $' + amount;
	                   }else if(parsed[key] === 'true' || parsed[key] === 'false'){
	                        arrayHTML += itm.title + ': ' + ((parsed[key] === 'true') ? 'Yes' : 'No');
	                   }else if(isLink(parsed[key])) {
						    arrayHTML +=  '<a href="' + parsed[key] + '" target="_blank">' + itm.title + '</a><br/>';
					   }else{
	                        arrayHTML += itm.title + ': ' + parsed[key];
	                   }	
					   arrayHTML += '<br>';
					});
				} else {
	                var parsed = JSON.parse(value);
					for (var key in parsed) {
					   if (parsed.hasOwnProperty(key)) {
					      var displayKey = key.charAt(0).toUpperCase() + key.slice(1); // Capitalize first letter

					      if(displayKey.endsWith('Fee') || displayKey.endsWith('fee')){
					         let amount = parsed[key];
					         if (!isNaN(amount) && amount !== '') {
					            amount = Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					         }
					         arrayHTML += displayKey + ': $' + amount + '<br>';
					      }else if(parsed[key] === 'true' || parsed[key] === 'false'){
					         arrayHTML += displayKey + ': ' + ((parsed[key] === 'true') ? 'Yes' : 'No');
					      }else if(isLink(parsed[key])) {
						    arrayHTML +=  '<a href="' + parsed[key] + '" target="_blank">' + displayKey + '</a><br/>';
					      }else{
					         arrayHTML += displayKey + ': ' + parsed[key];
					      }	
					      arrayHTML += '<br>';
					   }
					}
				}
                return arrayHTML;
			}
			
			function isLink(value) {
				if(value) {
					return value.trim().startsWith("http") || value.trim().startsWith("www") || value.trim().startsWith("/");
				}
				
				return false;
			}

            function loadCourseDetails(course, index, selectCourses){
                var isEmpty = !course;    
                var disabledClass = course.path === '' ? ' disabled' : '';

                var selectCourses = '<select name="courseOption_'+ index +'" class="course-selector"><option value="" disabled selected>Select</option>';  
                savedCourses.forEach(function(courseOption) {
                    var selected = (!isEmpty && courseOption.path === course.path) ? ' selected' : '';
                    selectCourses += '<option value="' + courseOption.path + '"' + selected + '>' + courseOption.courseName + '</option>';
                });          
                selectCourses += '</select>'; 

                var courseCardInfo = '';
                var extraFieldsHTML = createExtraFieldsHTML(course);

                courseCardInfo = 
                    '<div class="course-card" data-path="' + course.path + '" data-course-id="course' + index + '">' +
                    '<div class="course-comparison__title">' + selectCourses + '</div>' +
                    '<div class="course-comparison__image"><a href="'+ course.path +'"><img src="' + course.previewImagePath + '" /></a></div>' +
                    '<div class="course-comparison__name">' + course.courseName + '</div>' +
                    '<div class="course-comparison__dataField">' + extraFieldsHTML + '</div>' +
                    '<div class="course-button' + disabledClass + '"><a class="classic_white_button_navy_border style_round_button" href="' + course.path + '">See course detail</a></div>' + 
                    '<div class="course-button' + disabledClass + '"><a class="classic_summer_red_button_white_text style_round_button" href="' + course.path + '#enquiry">Enquire</a></div></div>';

                return courseCardInfo;
            }

            function checkFieldKeySizes(){
                fieldKeys.forEach(key => {
                    var elements = component.querySelectorAll('.course-field-group.' + key);
                    var maxHeight = 0;
                    
                    elements.forEach(function(el) {
                        el.style.height = 'auto'; // reset
                        var h = el.offsetHeight;
                        if (h > maxHeight) maxHeight = h;
                    });

                    elements.forEach(function(el) {
                        el.style.height = maxHeight + 'px';
                    });
                });

                var courseNames = component.querySelectorAll('.course-comparison__name');
                var courseNameHeight = 0;
                
                courseNames.forEach(function(el){
                    el.style.height = 'auto'; 
                    var h = el.offsetHeight;
                    if (h > courseNameHeight) courseNameHeight = h;
                });

                courseNames.forEach(function(el) {
                    el.style.height = courseNameHeight + 'px';
                });
            }

            initSavedCourses();
            monitorSavedCoursesChange('flinders_saved_courses', initSavedCourses);

            function debounce(fn, delay) {
                var timer;
                return function () {
                    clearTimeout(timer);
                    timer = setTimeout(fn, delay);
                };
            }

            $(document).on('change', '.cmp-flindersonline-compare-courses .course-card .course-selector', function (e) {
                const target = $(this);
                const selected = target.val();
                const coursedata = target.closest('.course-card').data('course-id');
                const courseCard = target.closest('.course-card').get(0);
                const courseIndex = coursedata.replace('course', '');
                const coursePath = target.closest('.course-card').data('path');
                
                if(selected){
                    savedCourses.forEach((course,index) => {
                        if(selected === course.path){
                            courseCard.innerHTML = loadCourseDetails(course,index);
                        }
                    });
                }

                checkFieldKeySizes();

                if (selected === '') {
                    target.addClass('default');
                } else {
                    target.removeClass('default');
                }
            });

            var resizeTimeout;
            function handleResize() {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {	
                    checkFieldKeySizes();
                }, 250); 
            } 
            window.addEventListener('resize', handleResize);
            
            function getCookie(name) {
		        return document.cookie
		            .split('; ')
		            .find(row => row.startsWith(`${name}=`))
		            ?.split('=')[1] || null;
		    }

            const debouncedReload = debounce(initSavedCourses, 200);             
        })
    }
});